import React from "react";
import ProfileTabs from "../Components/ProfileTabs";

const ProfilePage = () => {
  return (
    <div className="min-h-screen bg-gray-50/50 py-12 px-4 sm:px-6 lg:px-8">
      {/* Centered Profile Section */}
      <div className="w-100 mx-auto space-y-8">
        <div className="text-center sm:text-left">
          <h1 className="text-xl font-extrabold text-gray-950 tracking-tight">Profile Details</h1>
          <p className="mt-2 text-sm text-gray-600 font-medium">Keep your account secure and up-to-date.</p>
        </div>

        {/* PROFILE TABS COMPONENT */}
        <ProfileTabs />

        {/* Help section (Optional) */}
        <div className="text-center">
            <p className="text-sm text-gray-400 font-medium">
                Need help? Contact support at <a href="mailto:hr@lagran.in" className="text-[#00B8D9] hover:underline">hr@lagran.in</a>
            </p>
        </div>
      </div>
    </div>
  );
};

export default ProfilePage;
